import apiClient from "./api";

export interface Client {
  id: number;
  companyName: string;
  emailAddress: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  phone1: string;
  phone2: string | null;
  fax: string | null;
  statusID: number;
  statusName?: string;
  typeID: number;
  typeName?: string;
  createdDate: string;
  primaryAccountID: number | null;
  primaryContactName?: string;
}

export interface ClientDetails extends Client {
  primaryContact?: {
    id: number;
    firstname: string;
    lastname: string;
    emailAddress: string;
    phone1: string;
    title: string;
  };
}

export interface CreateClientData {
  companyName: string;
  emailAddress: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zipcode: string;
  country?: string;
  phone1: string;
  phone2?: string;
  fax?: string;
  typeID: number;
  contactFirstname: string;
  contactLastname: string;
  contactEmail: string;
  contactPhone: string;
  contactTitle?: string;
  contactUsername: string;
  contactPassword: string;
}

export interface UpdateClientData {
  companyName?: string;
  emailAddress?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
  phone1?: string;
  phone2?: string;
  fax?: string;
  statusID?: number;
  typeID?: number;
}

export interface EntityType {
  id: number;
  description: string;
}

export const clientService = {
  async getClients(search?: string): Promise<Client[]> {
    const params = search ? { search } : {};
    const response = await apiClient.get("/clients", { params });
    return response.data.clients;
  },

  async getClientById(id: number): Promise<ClientDetails> {
    const response = await apiClient.get(`/clients/${id}`);
    return response.data.client;
  },

  async createClient(data: CreateClientData): Promise<{
    clientId: number;
    accountId: number;
  }> {
    const response = await apiClient.post("/clients", data);
    return {
      clientId: response.data.clientId,
      accountId: response.data.accountId,
    };
  },

  async updateClient(id: number, data: UpdateClientData): Promise<void> {
    await apiClient.put(`/clients/${id}`, data);
  },

  async getEntityTypes(): Promise<EntityType[]> {
    const response = await apiClient.get("/clients/entity-types");
    return response.data.types;
  },
};
